import React from 'react';

let  Loading = (props) => {
    return (
        <div className='loader'></div>
    );
};

export default Loading;